import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DatasourceSyncViewModel, RestartDatasyncLocalStoreService } from './restart-datasync-local-store.service';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { SyncActions } from '../../../state/location-list-actions';
import { TranslateModule } from '@ngx-translate/core';
import { DatePipe, NgClass } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { MatButton, MatIconButton } from '@angular/material/button';
import { LetDirective } from '@ngrx/component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-restart-datasync',
    templateUrl: './restart-datasync.component.html',
    styleUrls: ['./restart-datasync.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [RestartDatasyncLocalStoreService],
    standalone: true,
  imports: [LetDirective, MatButton, MatMenuTrigger, MatIcon, MatMenu, MatProgressBar, MatIconButton, MatTooltip, NgClass, DatePipe, TranslateModule, MatProgressSpinner],
})

export class RestartDatasyncComponent {

  viewModel$: Observable<DatasourceSyncViewModel> = this.localStore.viewModel$;

  constructor(private localStore: RestartDatasyncLocalStoreService, private store: Store) {
  }

  getSyncDetails() {
    this.store.dispatch(SyncActions.getDatasourceSyncDetails({}));
  }

  restartDataSync() {
    this.store.dispatch(SyncActions.restartDatasourceSync({ triggeredByUser: true }));
  }

}
